module.exports = __webpack_public_path__ + "img/amazon-appstore-badge-english-black.484d5f5f.png";